import { render, staticRenderFns } from "./PopupBonuses.vue?vue&type=template&id=ae1a073e"
import script from "./PopupBonuses.vue?vue&type=script&lang=js"
export * from "./PopupBonuses.vue?vue&type=script&lang=js"
import style0 from "./PopupBonuses.vue?vue&type=style&index=0&id=ae1a073e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports